import { render, staticRenderFns } from "./InspectDetailQuery.vue?vue&type=template&id=f3b36c78&scoped=true"
import script from "./InspectDetailQuery.vue?vue&type=script&lang=js"
export * from "./InspectDetailQuery.vue?vue&type=script&lang=js"
import style0 from "./InspectDetailQuery.vue?vue&type=style&index=0&id=f3b36c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b36c78",
  null
  
)

export default component.exports